import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { LocalStorageService } from 'ngx-webstorage';
import { ParametrosService } from 'projects/fr/src/api/services';
import { PAGE_SIZE_KEY } from 'projects/fr/src/app/utilities/constants';
import { Subscription, switchMap, timer } from 'rxjs';
import { ApiConfiguration } from '../api/api-configuration';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private _subs$ = new Subscription();

  constructor(
    private apiConfig: ApiConfiguration,
    iconRegistry: MatIconRegistry,
    private readonly systemParametersService: ParametrosService,
    private readonly localSt: LocalStorageService,
  ) {
    iconRegistry.registerFontClassAlias('rounded', 'material-icons-round');
  }

  ngOnInit(): void {
    this.apiConfig.rootUrl = environment.apiUrl;

    this._subs$.add(
      // 5 min
      timer(0, 300_000)
        .pipe(
          switchMap(() =>
            this.systemParametersService.getParametros({
              criteria: {
                codigo: 'global.pageSize',
                size: 1,
              },
            }),
          ),
        )
        .subscribe((res) => {
          if (res.pageData.length === 1) {
            this.localSt.store(PAGE_SIZE_KEY, res.pageData[0].valor);
          }
        }),
    );
  }

  ngOnDestroy(): void {
    this._subs$.unsubscribe();
  }
}
